const userAgent: string = window.navigator.userAgent.toLocaleLowerCase();
const isWebviewIOS: boolean = !userAgent.includes('safari') && !userAgent.includes('firefox');
const isWebviewAndroid: boolean = userAgent.includes('wv');

//isWebviewIOS: solo es true cuando estas dentro de la app nativa de iOS.
//isWebviewAndroid: solo es true cuando estas dentro de la app nativa de android.
export { isWebviewIOS, isWebviewAndroid };
